import SkeletonCard from './SkeletonCard';

export default SkeletonCard;
